<template>
	<div class="d-flex align-items-center min-vh-100">
		<div class="container">
			<div class="row">
				<div class="col-md-4 offset-md-4" v-if="loading">
					<div class="card animate__animated animate__fadeIn">
						<div class="card-body">
							<loading-spinner />
						</div>
					</div>
				</div>
				<div class="col" v-else>
					<div class="card animate__animated animate__fadeIn">
						<div class="card-body">
							<div class="row gap-3 gap-md-0">
								<div class="col-md-6">
									<div class="list-group">
										<div class="list-group-item bg-primary text-white text-center">
											<strong>ТОП-10 ЛИДЕРОВ ПО УРОВНЯМ</strong>
										</div>
										<div class="list-group-item text-center text-muted py-0">
											<div class="row">
												<div class="col-4 col-md-2 text-center">уровень</div>
												<div class="col-6 col-md-8 text-center">ник</div>
												<div class="col-2"></div>
											</div>
										</div>
										<div class="list-group-item text-center py-0" :class="{'list-group-item-warning': index < 3}" v-for="(item, index) in results.level" :key="item.id">
											<div class="row">
												<div class="col-4 col-md-2 d-flex justify-content-center align-items-center">
													<div>
														<div>{{item.level||'?'}}</div>
														<div class="fs-07">{{item.seconds}}c</div>
													</div>
												</div>
												<div class="col-6 col-md-8 d-flex justify-content-center align-items-center">{{item.username||'Игрок'}}</div>
												<div class="col-2 d-flex justify-content-end align-items-center">
													
												</div>
											</div>
										</div>
									</div>
								</div>
								<div class="col-md-6">
									<div class="list-group">
										<div class="list-group-item bg-primary text-white text-center">
											<strong>ТОП-10 ЛИДЕРОВ ПО ОЧКАМ</strong>
										</div>
										<div class="list-group-item text-center text-muted py-0">
											<div class="row">
												<div class="col-4 col-md-2 text-center">очков</div>
												<div class="col-6 col-md-8 text-center">ник</div>
												<div class="col-2"></div>
											</div>
										</div>
										<div class="list-group-item text-center py-0" :class="{'list-group-item-warning': index < 3}" v-for="(item, index) in results.exp" :key="item.id">
											<div class="row">
												<div class="col-4 col-md-2 d-flex justify-content-center align-items-center">
													<div>
														<div>{{item.exp||'?'}}</div>
														<div class="fs-07">{{item.seconds}}c</div>
													</div>
												</div>
												<div class="col-6 col-md-8 d-flex justify-content-center align-items-center">{{item.username||'Игрок'}}</div>
												<div class="col-2 d-flex justify-content-end align-items-center">
													
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="row mt-3">
								<div class="col text-center">
									<router-link :to="{path: '/', query: {u: username}}" class="btn btn-lg btn-primary">На главную</router-link>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="row mt-3" v-if="error">
				<div class="col">
					<div class="alert alert-warning alert-dismissible" role="alert">
						{{error}}
						<button type="button" class="btn-close" aria-label="Close" @click="error = ''"></button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style lang="scss">
.fs-07 {
	font-size: 0.7rem;
}
</style>

<script>
import lib from '@/lib';
import { useMeta } from 'vue-meta';

import LoadingSpinner from '@/components/LoadingSpinner';

export default {
	mixins: lib.mixins,
	setup(){
		useMeta({title: 'Результаты | TankOn2'});
	},
	data: () => ({
		loading: false,
		error: 'xxx',
		
		username: '',
		
		results: {
			level: [],
			exp: [],
		},
	}),
	methods: {
		async getResults(){
			this.loading = true;
			this.error = '';
			const ret = await this.appModel.doGetResults();
			if(ret.success){
				this.results.level = ret.level || [];
				this.results.exp = ret.exp || [];
			} else {
				this.error = ret.message;
			}
			this.loading = false;
		},
	},
	async mounted(){
		if(this.$route.query.u) this.username = this.$route.query.u;
		else this.username = this.authModel.getLogin();
		
		await this.getResults();
	},
	async beforeRouteUpdate(to, from, next){
		if(to.query.u != this.username) this.username = to.query.u || '';
		else this.username = this.authModel.getLogin();
		
		await this.getResults();
		next();
	},
	components: {
		LoadingSpinner,
	},
}
</script>